import React from 'react';
import SplitViewFieldsGrid from '../../../../../components/generic/SplitViewFieldsGrid';
import { useTheme } from '../../../../../contexts/ThemeContext';
import { cn } from '../../../../../lib/utils';
import { API_ENDPOINTS } from '../../../../../config/apiConfig';
import { ApprovalIntegration } from '../../../../../components/generic';
import { documentConfig } from '../../documentConfig';

const DocumentDetailsTab = ({ 
  selectedRecord, 
  selectedRecordFiles, 
  config, 
  fields 
}) => {
  const { theme } = useTheme();

  return (
    <div 
      className="p-4 flex-1 overflow-y-auto advanced-table-scroll"
      style={{ 
        scrollbarWidth: 'thin',
        minHeight: 0,
        maxHeight: '100%'
      }}
    >
      <div className="grid grid-cols-1 gap-4">
        {/* Document Review and Approval Integration - Moved to top */}
        {documentConfig.shouldShowApprovalInDetails() && (
          <div className="mb-6">
            <ApprovalIntegration 
              entity={selectedRecord}
              entityType="document"
              entityData={{
                documentCode: selectedRecord.code,
                documentTitle: selectedRecord.title,
                documentType: selectedRecord.documentType?.name,
                department: selectedRecord.department?.name,
                status: selectedRecord.status?.name,
                version: selectedRecord.version,
                description: selectedRecord.description,
                effectiveDate: selectedRecord.effectiveDate,
                reviewDate: selectedRecord.reviewDate,
                createdBy: selectedRecord.createdBy?.userDisplayName,
                createdAt: selectedRecord.createdAt
              }}
              onApprovalUpdate={(approval) => {
                console.log('Review and approval updated:', approval);
                // You can add additional logic here to refresh the document data
              }}
              customTitle="Document Review and Approval Status"
              customButtonText={documentConfig.approval.approvalButtonText}
              showEntityDetails={documentConfig.approval.showApprovalStatus}
              showApprovalActions={documentConfig.approval.showApprovalActions}
              showApprovalHistory={documentConfig.approval.showApprovalHistory}
              formMode={documentConfig.approval.formMode || 'standalone'}
              config={{
                defaultApprovalType: documentConfig.approval.defaultApprovalType,
                allowMultipleApprovals: documentConfig.approval.allowMultipleApprovals
              }}
            />
          </div>
        )}

                <SplitViewFieldsGrid
          selectedRecord={selectedRecord}
          fields={fields}
          config={config}
          layout="boxed"
        />
        
        {/* File Attachments are only for revisions, not documents */}
      </div>
    </div>
  );
};

export default DocumentDetailsTab;
